import React from 'react';
import {
  Drawer, Form, Input, Select, Button, Row, Col, Space, message, Switch
} from 'antd';
import { getEmpleados } from '../../../../apis/OdooApi';
import { insert, update } from '../../../../apis/SupervisoresApi';

const UpsertSupervisor = ({
  mode = 'create',              // 'create' | 'edit'
  record = null,                // supervisor a editar (cuando mode='edit')
  open: openProp,               // controla visible del Drawer en modo edit
  onClose: onCloseProp,         // callback al cerrar en modo edit
  onSaved                      // callback para refrescar lista
}) => {
  const isEdit = mode === 'edit';

  // Si es create, mantenemos un estado interno; si es edit, usamos el prop
  const [internalOpen, setInternalOpen] = React.useState(false);
  const open = isEdit ? openProp : internalOpen;

  const handleOpenCreate = async () => {
    setInternalOpen(true);
    if (!empleados.length) {
      const data = await getEmployees();
      setEmpleados(data);
    }
  };

  const handleClose = () => {
    resetForm();
    if (isEdit) onCloseProp?.();
    else setInternalOpen(false);
  };

  const [loading, setLoading] = React.useState(false);
  const [empleados, setEmpleados] = React.useState([]);
  const [form] = Form.useForm();

  const getEmployees = React.useCallback(async () => {
    const resp = await getEmpleados();
    return (resp?.ok && Array.isArray(resp.payload)) ? resp.payload : [];
  }, []);

  // Cargar opciones y setear valores cuando abre
  React.useEffect(() => {
    if (!open) return;
    (async () => {
      if (!empleados.length) {
        const data = await getEmployees();
        setEmpleados(data);
      }
      // Prefill si edita; si crea, valores por defecto
      if (isEdit && record) {
        form.setFieldsValue({
          short_code: record.short_code ?? '',
          activo: record.activo ?? true,
          empleado_id_one2many: record.empleado_id_one2many ?? null,
        });
      } else {
        form.setFieldsValue({ activo: true });
      }
    })();
  }, [open, isEdit, record, empleados.length, form, getEmployees]);

  const resetForm = () => form.resetFields();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        empleado_id_one2many:
          values.empleado_id_one2many === undefined || values.empleado_id_one2many === ''
            ? null
            : Number(values.empleado_id_one2many),
      };

      const res = isEdit
        ? await update({ id: record.id, ...payload })
        : await insert(payload);

      if (res?.ok) {
        message.success(isEdit ? 'Supervisor actualizado' : 'Supervisor creado');
        resetForm();
        if (!isEdit) setInternalOpen(false);
        else onCloseProp?.();
        onSaved?.();
      } else {
        message.error(res?.message || (isEdit ? 'No se pudo actualizar' : 'No se pudo crear'));
      }
    } catch (err) {
      console.error(err);
      message.error(isEdit ? 'Error al actualizar el supervisor' : 'Error al crear el supervisor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {!isEdit && (
        <Button type="primary" onClick={handleOpenCreate}>
          Agregar Supervisor
        </Button>
      )}

      <Drawer
        title={isEdit ? 'Editar Supervisor' : 'Agregar Supervisor'}
        open={open}
        onClose={handleClose}
        width={720}
        destroyOnClose
        extra={
          <Space>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button type="primary" onClick={() => form.submit()} loading={loading}>
              {isEdit ? 'Guardar cambios' : 'Guardar'}
            </Button>
          </Space>
        }
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          {!isEdit && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
              <Button type="link" onClick={resetForm}>Limpiar formulario</Button>
            </div>
          )}

          <Row gutter={12}>
            <Col span={14}>
              <Form.Item
                label="Empleado"
                name="empleado_id_one2many"
                rules={[{ required: true, message: 'Selecciona un empleado' }]}
              >
                <Select
                  placeholder="Selecciona un empleado"
                  options={empleados.map(emp => ({
                    label: emp.text,
                    value: Number(emp.value),
                  }))}
                  loading={!empleados.length && open}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label="Código corto" name="short_code">
                <Input placeholder="Ej. SUP01" maxLength={50} allowClear />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label="Activo" name="activo" valuePropName="checked" initialValue={true}>
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default UpsertSupervisor;